import React, { useState } from 'react';
import '../styles/DropdownExample.css';

const skillOptions = [
  'Java',
  'Python',
  'Selenium',
  'API Testing',
  'TestNG',
  'Cucumber',
  'Generative AI',
  'DevOps',
];

const DropdownExample = () => {
  const [jobTitle, setJobTitle] = useState('');
  const [selectedSkills, setSelectedSkills] = useState([]);

  const handleSkillsChange = (event) => {
    const values = Array.from(event.target.selectedOptions, (option) => option.value);
    setSelectedSkills(values);
  };

  return (
    <div className="dropdown-example">
      <h2 className="dropdown-heading">Dropdown</h2>

      <div className="dropdown-fields">
        <div className="inputField__wrapper dropdown-single-field">
          <span className="dropdown-field-type">Single select</span>
          <label htmlFor="jobTitle">Job title</label>
          <select
            id="jobTitle"
            className="select__select"
            name="jobTitle"
            value={jobTitle}
            onChange={(e) => setJobTitle(e.target.value)}
          >
            <option value="" disabled>
              Select a job title
            </option>
            <option value="Consulting">Consulting</option>
            <option value="Customer Service">Customer Service</option>
            <option value="Engineering">Engineering</option>
            <option value="Executive Management">Executive Management</option>
            <option value="Finance/Legal/Administration">Finance/Legal/Administration</option>
            <option value="Help Desk">Help Desk</option>
            <option value="Human Resources">Human Resources</option>
            <option value="IT">IT</option>
            <option value="Marketing/PR">Marketing/PR</option>
            <option value="Operations">Operations</option>
            <option value="Professional Services">Professional Services</option>
            <option value="Sales/Business Development">Sales/Business Development</option>
            <option value="Telecommunications">Telecommunications</option>
            <option value="Training">Training</option>
            <option value="Other">Other</option>
          </select>
          {jobTitle && (
            <p className="dropdown-selection-summary" id="job-title-selection-summary">
              Selected: {jobTitle}
            </p>
          )}
        </div>

        <div className="inputField__wrapper dropdown-multi-field">
          <span className="dropdown-field-type">Multi select</span>
          <label htmlFor="skills">Learning Topics</label>
          <p className="dropdown-help-text" id="skills-help-text">
            Hold Ctrl on Windows or Command on Mac to select multiple options.
          </p>
          <select
            id="skills"
            className="select__select select__multi"
            name="skills"
            multiple
            value={selectedSkills}
            onChange={handleSkillsChange}
          >
            {skillOptions.map((skill) => (
              <option key={skill} value={skill}>
                {skill}
              </option>
            ))}
          </select>
          {selectedSkills.length > 0 && (
            <p className="dropdown-selection-summary" id="skills-selection-summary">
              Selected: {selectedSkills.join(', ')}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DropdownExample;
